export const biometricConstants = {
    BIOMETRIC_DATA_REQUEST: 'BIOMETRIC_DATA_REQUEST',
    BIOMETRIC_DATA_SUCCESS: 'BIOMETRIC_DATA_SUCCESS',
    BIOMETRIC_DATA_FAILURE: 'BIOMETRIC_DATA_FAILURE'
  }